module.exports = __webpack_public_path__ + "static/media/contact.3ad4cd49.svg";